/**
 * OnboardingGate - DISABLED
 * 
 * This component has been completely disabled because App.tsx now handles all redirect logic.
 * Keeping this file for backwards compatibility, but it does absolutely nothing.
 */
export default function OnboardingGate() {
  return null;
}
